<div class="panel fb-place-wrap fixed-height-panel">
    <div class="panel-header">
        <h1 [class.text-disabled]="!enabled">Add Google Place by Name</h1>
        <mat-icon [class.text-disabled]="!enabled" tip matTooltip="Search Google places by name">
            info
        </mat-icon>
        <upgrade-button [show]="!enabled" [css]="'upgrade-create-place'"></upgrade-button>
    </div>
    <ig-field class="m-t-4"
            label="Search Google place name"
            [(ngModel)]="placeName"
            [isRequired]="true"
            [disabled]="!enabled"
            [formControl]="placeFormGroup.get('placeName')"
    ></ig-field>

    <ig-button color="accent"
               [isAsync]="true" size="md"
               [disabled]="placeFormGroup.invalid||!enabled"
               (trigger)="search($event)">
        Search
    </ig-button>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.account/content.management/search.google.place/search.google.place.component.html